/* eslint-disable */
import * as R from 'ramda';
import moment from 'moment';
import axios from 'axios'
// 获取指定hash值
export function getHashParameter(key) {
  const arr = (location.hash || '').replace(/^\#/, '').split('&');
  const params = {};
  for (let i = 0; i < arr.length; i++) {
    const data = arr[i].split('=');
    if (data.length == 2) {
      params[data[0]] = data[1];
    }
  }
  return params[key];
}

// 获取路由指定参数
export function getParam(paramName) {
  let paramValue = '';
  let isFound = !1;
  const { location } = window;
  if (location.search.indexOf('?') == 0 && location.search.indexOf('=') > 1) {
    const arrSource = unescape(location.search)
      .substring(1, location.search.length)
      .split('&');
    let i = 0;

    while (i < arrSource.length && !isFound)
      arrSource[i].indexOf('=') > 0 &&
        arrSource[i].split('=')[0].toLowerCase() == paramName.toLowerCase() &&
        ((paramValue = arrSource[i].split('=')[1]), (isFound = !0)),
        i++;
  }

  return paramValue == '' && (paramValue = null), paramValue;
}

export function translateObjToString(obj) {
  let str = '?';
  Object.keys(obj).map(item => {
    if (obj[item] || obj[item] === 0) {
      if (str === '?') {
        str += `${item}=${obj[item]}`;
      } else {
        str += `&${item}=${obj[item]}`;
      }
    }
    return str;
  });
  return str === '?' ? '' : str;
}

export function getByteLen(value) {
  // 传入一个字符串
  let len = 0;

  if (value) {
    for (let i = 0; i < value.length; i++) {
      // eslint-disable-next-line no-control-regex
      if (value[i].match(/[^\x00-\xff]/gi) != null)
        // 全角
        len += 2;
      // 如果是全角，占用两个字节  如果mysql中某字段是text, 如果设置编码为utf-8,那么一个中文是占3个字节, gbk是两个字节
      else len += 1; // 半角占用一个字节
    }
  }

  return len;
}

export function cutStr(str, len) {
  let result = '';
  const strLen = str.length; // 字符串长度
  // eslint-disable-next-line no-control-regex
  const chrLen = str.replace(/[^\x00-\xff]/g, '**').length; // 字节长度

  if (chrLen <= len) {
    return str;
  }

  for (let i = 0, j = 0; i < strLen; i++) {
    const chr = str.charAt(i);

    // eslint-disable-next-line no-control-regex
    if (/[\x00-\xff]/.test(chr)) {
      j += 1; // ascii码为0-255，一个字符就是一个字节的长度
    } else {
      j += 2; // ascii码为0-255以外，一个字符就是两个字节的长度
    }

    if (j <= len) {
      // 当加上当前字符以后，如果总字节长度小于等于len，则将当前字符真实的+在result后
      result += chr;
    } else {
      // 反之则说明result已经是不拆分字符的情况下最接近len的值了，直接返回
      return result;
    }
  }
}

export function getElementPos(element) {
  let actualLeft = element.offsetLeft;
  let actualTop = element.offsetTop;

  let current = element.offsetParent;

  while (current !== null) {
    actualLeft += current.offsetLeft;
    actualTop += current.offsetTop;
    current = current.offsetParent;
  }

  return {
    x: actualLeft,
    y: actualTop,
  };
}

// 获取当前月的开始时间
export function getCurrMonthDays() {
  const date = [];
  const start = `${moment()
    .add('month', 0)
    .format('YYYY-MM')}-01 00:00:00`;
  const end = `${moment().format('YYYY-MM-DD')} 23:59:59`;
  date.push(moment(start), moment(end));

  return date;
}

// 获取一周的时间范围
export function getWeekDays() {
  const date = [];
  var dd = new Date();
  dd.setDate(dd.getDate() - 6); // 获取一周前的时间
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1; //获取当前月份的日期
  if (m < 10) {
    m = '0' + m;
  }
  var d = dd.getDate();
  if (d < 10) {
    d = '0' + d;
  }
  const start = `${y}-${m}-${d} 00:00:00`;
  const end = `${moment().format('YYYY-MM-DD')} 23:59:59`;
  date.push(moment(start), moment(end));

  return date;
}

// 判断是否为有值数组，类型为数组且长度大于0
export const hasValueArray = R.both(
  Array.isArray,
  R.compose(
    R.gt(R.__, 0),
    R.length,
  ),
);

//随机字符串加密
export function generateHash() {
  const str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  return Array.from(Array(32), () => str[Math.floor(Math.random() * 62)]).join('');
}

// 获取指定cookie值
export function getCookie(cookieName) {
  let strCookie = window.document.cookie
  let arrCookie = strCookie.split("; ")
  for (let i = 0; i < arrCookie.length; i++) {
    let arr = arrCookie[i].split("=")
    if (cookieName === arr[0]) {
      return arr[1]
    }
  }
  return ""
}

export const setCookie = (key, value, options) => {
  if (value !== undefined) {
    if (options && typeof options.expires === "number") {
      let days = options.expires,
        t = (options.expires = new Date());
      t.setDate(t.getDate() + days);
    }

    return (document.cookie = [
      key,
      "=",
      value,
      options.expires ? "; expires=" + options.expires.toUTCString() : "", // use expires attribute, max-age is not supported by IE
      options.path ? "; path=" + options.path : "",
      options.domain ? "; domain=" + options.domain : "",
      options.secure ? "; secure" : ""
    ].join(""));
  }
};

export const removeCookie = (key, options = {}) => {
  if (key !== undefined) {
    setCookie(key, "", { ...options, expires: -1 });
    return true;
  }
  return false;
};

export const getUserInfo = async () => {
  try {
    let token = getCookie('ekt_access_token')
    let url = `${window.__config.account}/oauth2/userinfo`

    let resp = await axios({
      url,
      method: 'get',
      headers: {
        authorization: 'Bearer ' + token
      }
    })

    if (resp.status == 200) {
      let user = {
        access_token: token,
        scope: "openid",
        token_type: "Bearer",
        profile: resp.data
      }

      user = JSON.stringify(user);
      localStorage.setItem('user', user);
    }
  } catch (error) {
  }
}
